module.exports = __webpack_public_path__ + "static/img/AIMicroCircle.dfec870e.png";